import { call, put, select } from 'redux-saga/effects';
import { setBillingDetails } from '../../../effects/organization';
import { setBannerAPIRequestState } from '../../../effects/message';
import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';

export default function* createBilling({ payload }) {
  const organizationId = yield select((state) => state.organization.uuid);
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${
    dpaApiBaseUrl + RESOURCES.ORGA
  }/${organizationId}/billing?displayBilling=true`;
  try {
    const { success, error, result } = yield call(callAPI, {
      url,
      method: METHODS.POST,
      body: payload.data,
    });
    if (!error && success) {
      yield put(setBillingDetails({ result, billingSuccess: success }));
    } else {
      yield put(
        setBannerAPIRequestState({
          bannerState: 'error',
          bannerMessage:
            'An error occured during the Subscription with registering your card. Please Try again.',
        }),
      );
      yield put(setBillingDetails({ result: null, billingSuccess: false }));
    }
  } catch (e) {
    console.error(e);
  }
}
